// Curated production imagery. Owned assets from PT ANP hosted on Emergent CDN.
// Non-owned assets are placeholders — TODO(client) markers below.

// HERO — Owned Indonesian tea plantation drone reel.
// Served locally: WebM/VP9 (5.9 MB, royalty-free — plays everywhere incl.
// Chromium builds without H.264) with H.264 MP4 fallback (7.2 MB).
// Both transcoded from the owned 14.8 MB original: faststart, no audio.
export const HERO_VIDEO = {
  webm: "/hero-tea.webm",
  mp4: "/hero-tea.mp4",
  // Poster shown until the video buffers. TODO(client): replace with a still
  // frame captured from the owned drone reel for perfect brand consistency.
  poster:
    "https://images.unsplash.com/photo-1756286477551-734d185a62de?w=2400&q=90",
};

// Landscape / plantation imagery — content-verified (placeholders).
export const PLANTATION_HERO =
  "https://images.unsplash.com/photo-1756286477551-734d185a62de?w=2400&q=90";

export const ABOUT_HERO =
  "https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=2400&q=90";

export const SUSTAINABILITY_HERO =
  "https://images.unsplash.com/photo-1587049352846-4a222e784d38?w=2400&q=90";

// Roasted green tea — atmospheric dark hero for the cinematic RGT landing hero.
export const RGT_HERO =
  "https://images.unsplash.com/photo-1677246999946-5aa3289c478c?w=2400&q=90";

export const RGT_STRIP =
  "https://images.unsplash.com/photo-1677246999946-5aa3289c478c?w=2400&q=85";

// Owned ANP "Pekoe Chocui" roasted green tea product shot (white background).
export const RGT_PRODUCT_SHOT =
  "https://customer-assets.emergentagent.com/job_premium-tea-export/artifacts/zjatdgi8_Pekoe%20Chocui.jpg";

export const OEM_BG =
  "https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?w=2400&q=85";

export const EXPORT_BG =
  "https://images.pexels.com/photos/2226458/pexels-photo-2226458.jpeg?auto=compress&cs=tinysrgb&w=2400&q=85";

export const QUALITY_LAB =
  "https://images.pexels.com/photos/11589239/pexels-photo-11589239.jpeg?auto=compress&cs=tinysrgb&w=2400&q=85";

// Owned Green Tea grade photography (product-shot on white with ANP branding).
export const GREEN_TEA_GRADES = [
  {
    name: "Chun Mee",
    slug: "chun-mee",
    tagline: "Signature Indonesian green — twisted, aromatic, aromatic-forward.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-tea-export/artifacts/9bte5358_CM.jpg",
  },
  {
    name: "Gun Powder",
    slug: "gunpowder",
    tagline: "Tightly rolled pellets — bold, long shelf life, tea-bag ready.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-tea-export/artifacts/72je1nz2_GP.jpg",
  },
  {
    name: "Broken Tea",
    slug: "broken",
    tagline: "Uniform broken leaf — versatile for blending and RTD extraction.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-tea-export/artifacts/i7w2xibb_BT.jpg",
  },
  {
    name: "Fannings",
    slug: "fannings",
    tagline: "Fine cut — rapid infusion for tea bags and stick packs.",
    image:
      "https://customer-assets.emergentagent.com/job_premium-tea-export/artifacts/g276prdq_Fannings.jpg",
  },
];

// Product category imagery — owned ANP photography.
export const PRODUCT_IMAGES = {
  // Owned — Gunpowder green tea (iconic rolled pellet grade).
  "green-tea":
    "https://customer-assets.emergentagent.com/job_premium-tea-export/artifacts/72je1nz2_GP.jpg",
  // Owned — Pekoe Chocui roasted green tea.
  "roasted-green-tea":
    "https://customer-assets.emergentagent.com/job_premium-tea-export/artifacts/zjatdgi8_Pekoe%20Chocui.jpg",
  // Owned — Broken Orange Pekoe black tea (whole dark twisted leaf).
  "black-tea":
    "https://customer-assets-jai6qajn.emergentagent.net/job_premium-tea-export/artifacts/yffnwl8t_BOP.jpg",
  // Owned — roasted oolong tea.
  "oolong-tea":
    "https://customer-assets.emergentagent.com/job_premium-tea-export/artifacts/1lq0l3t6_ROT.jpg",
  // Owned — Specialty Tea (fine dark grade).
  "specialty-tea":
    "https://customer-assets-jai6qajn.emergentagent.net/job_premium-tea-export/artifacts/dobrhqpj_OP.jpg",
};

// Industry imagery — HTTP-verified.
export const INDUSTRY_IMAGES = {
  tea_brands:
    "https://images.unsplash.com/photo-1547825407-2d060104b7f8?w=1600&q=85",
  coffee_chains:
    "https://images.unsplash.com/photo-1509785289787-59357476ce6a?w=1600&q=85",
  bubble_tea:
    "https://images.pexels.com/photos/4790055/pexels-photo-4790055.jpeg?auto=compress&cs=tinysrgb&w=1600&q=85",
  hotels:
    "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1600&q=85",
  restaurants:
    "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1600&q=85",
  cafe:
    "https://images.unsplash.com/photo-1445116572660-236099ec97a0?w=1600&q=85",
  retail:
    "https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=1600&q=85",
  food:
    "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=1600&q=85",
  nutraceutical:
    "https://images.pexels.com/photos/3683051/pexels-photo-3683051.jpeg?auto=compress&cs=tinysrgb&w=1600&q=85",
  cosmetics:
    "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=1600&q=85",
};
